import SEOMeta from '@/components/base/SEOMeta';
import HomeHero from './components/HomeHero';
import CategoryNav from './components/CategoryNav';
import FeaturedContent from './components/FeaturedContent';
import LatestArticles from './components/LatestArticles';
import HomeFAQ from './components/HomeFAQ';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄瓜影院',
    url: 'https://huanggua.tv/',
    description: '黄瓜影院是您最佳的在线影视平台，提供海量高清电影、电视剧、综艺节目免费在线观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huanggua.tv/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黄瓜影院',
    url: 'https://huanggua.tv/',
    description: '海量高清影视资源免费在线观看平台',
    sameAs: ['https://weibo.com/huanggua', 'https://space.bilibili.com/huanggua'],
  };

  return (
    <>
      <SEOMeta
        title="黄瓜影院 - 海量高清影视资源免费在线观看"
        description="黄瓜影院是您最佳的在线影视平台，提供海量高清电影、电视剧、综艺节目免费在线观看。黄瓜影院收录最新最热门影视资源，支持多线路流畅播放，无需注册即可享受极致观影体验。"
        keywords="黄瓜影院,黄瓜影院在线观看,黄瓜影院高清电影,黄瓜影院最新电视剧,黄瓜影院免费播放,黄瓜影院官网入口,在线影院免费观看"
        canonicalUrl="https://huanggua.tv/"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <HomeHero />
      <CategoryNav />
      <FeaturedContent />
      <LatestArticles />
      <HomeFAQ />
    </>
  );
}